import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Check if auth is disabled via environment variable
const AUTH_DISABLED = process.env.REACT_APP_DISABLE_AUTH === 'true';

export function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();

  // If auth is disabled, render children directly
  if (AUTH_DISABLED) {
    return children;
  }

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#0a0e27] via-[#1a1f3a] to-[#0a0e27]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/em-admin-access/login" replace />;
  }

  if (adminOnly && user.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return children;
}
